/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import { useNavigate } from "react-router-dom";

function ChangePassword() {
  const navigate = useNavigate();
  /*
  const passwordRequirements = [
    "One special characters",
    "Min 6 characters",
    "One number (2 are recommended)",
    "Change it often",
  ];

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });
  */

  return (
    <Card id="change-password">
      <MDBox p={3}>
        <MDTypography variant="h5">Change Password</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        {/*}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              label="Current Password"
              inputProps={{ type: "password", autoComplete: "" }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              label="New Password"
              inputProps={{ type: "password", autoComplete: "" }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              fullWidth
              label="Confirm New Password"
              inputProps={{ type: "password", autoComplete: "" }}
            />
          </Grid>
        </Grid>
        <MDBox mt={6} mb={1}>
          <MDTypography variant="h5">Password requirements</MDTypography>
        </MDBox>
        {*/}
        <MDBox mb={2}>
          <MDTypography variant="body2" color="text" fontWeight="bold">
            Transition Process
          </MDTypography>
          <MDBox component="ol" m={0} mt={0.5} pl={3}>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              Click the <strong>Change Password</strong> button.
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              You will be redirected to the EnerScale <strong>Sign In</strong> page.
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              Enter your email address and click <strong>Continue</strong>.
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              You will be redirected to the password entry page.
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              Click &quot;<strong>Can&apos;t sign in? Reset password</strong>&quot; located below
              the password field.
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              Follow the instructions to reset and update your password.
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap">
          {/*}
          <MDBox component="ul" m={0} pl={3.25} mb={{ xs: 8, sm: 0 }}>
            {renderPasswordRequirements}
          </MDBox>
          {*/}
          <MDBox ml="auto">
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              onClick={() => navigate("/authentication/sign-out")}
            >
              change password
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ChangePassword;
